import { graphHooks } from '@tunasong/graph-lib/react'
import { useEditor } from '@tunasong/plugin-lib'
import { useCurrentUser } from '@tunasong/redux'
import type { Agent, Entity, Persisted } from '@tunasong/schemas'
import { isAgent } from '@tunasong/schemas'
import type { FC } from 'react'
import { NudgeBell } from './nudge-bell.js'
import { ProposalList } from './proposal-list.js'

export interface AgentIntegrationProps {
  entity: Persisted<Entity> | null | undefined
  /** Gate the integration behind a feature flag. */
  enabled?: boolean
  className?: string
}

/**
 * Single mount point the app shell uses to integrate agents with an entity.
 * Renders nudge bells and proposal lists for all agent children.
 */
export const AgentIntegration: FC<AgentIntegrationProps> = ({ entity, enabled = true, className }) => {
  const editor = useEditor({ allowNull: true })
  const { userId } = useCurrentUser()

  const { entities: children } = graphHooks.useEntityChildren<Persisted<Entity>>({
    parentId: entity?.id,
    skip: !enabled || !entity?.id,
  })

  const agents = children.filter(isAgent) as Persisted<Agent>[]

  if (agents.length === 0) {
    return null
  }

  return (
    <>
      {agents.map(agent => (
        <NudgeBell key={`nudge-${agent.id}`} agent={agent} className={className} />
      ))}
      {agents.map(agent => (
        <ProposalList
          key={`proposal-${agent.id}`}
          agent={agent}
          editor={editor}
          userId={userId}
          className={className}
        />
      ))}
    </>
  )
}
